import SharedDropZoneFileUpload from '../file-upload';

export default class SharedDropZoneCompactFileUpload extends SharedDropZoneFileUpload {}
